/* Sticky CTA reveal. The clone shipped BOTH CSS states -- hidden translateY(110%) and
   .pgl-is-visible{translateY(0)} -- but never the controller, so the bar sat 7px below the
   viewport at every scroll position on every page that had it. One shared copy. */
(function(){
  function boot(){
    var el = document.getElementById('pgl-sticky-pgl11sticky');
    if (!el) return;
    var shown = false;
    function sync(){
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      var want = y > 600;                       /* clear of the hero, before the first CTA */
      if (want !== shown) {
        shown = want;
        el.classList.toggle('pgl-is-visible', want);
        el.setAttribute('aria-hidden', want ? 'false' : 'true');
      }
    }
    window.addEventListener('scroll', sync, {passive:true});
    window.addEventListener('resize', sync, {passive:true});
    sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
